// socketIOSlice.ts

import { createSlice } from '@reduxjs/toolkit';
import { Socket } from 'socket.io-client';

interface SocketIOState {
  chatSocket: Socket  | null;
  notificationSocket: Socket | null;
}

const initialState: SocketIOState = {
  chatSocket: null,
  notificationSocket: null,
};

const socketIOSlice = createSlice({
  name: 'socketIO',
  initialState,
  reducers: {
    setChatSocket: (state, action) => {
      state.chatSocket = action.payload;
    },
    connectNotificationSocket: (state, action) => {
      state.notificationSocket = action.payload;
    },
  },
});

export const { setChatSocket, connectNotificationSocket } = socketIOSlice.actions;

export const selectChatSocket = (state: { socketIO: SocketIOState }) => state.socketIO.chatSocket;

export default socketIOSlice.reducer;
